module.exports = __webpack_public_path__ + "static/media/  (48).d7ec1a23.jpg";